import keyBy from 'lodash/keyBy';
import { useMemo } from 'react';
import { useAuth } from '../../../components/AuthContext/context';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery';
import type { CuratedDealBuyerDiscountSeat } from '../Form/types';

type UseSeatOptionsFetchOptions = {
  buyer_id?: string;
  demand_partner_id?: string;
  id__in?: string;
  name__contains?: string;
  seat_id?: string;
};

export const useSeatOptionsFetch = (skip?: boolean, options?: UseSeatOptionsFetchOptions) => {
  const { session } = useAuth();

  const accountId = session?.exchange_session?.account?.id;

  const { data, error, loading } = useOptionsByPathQuery({
    fetchPolicy: 'network-only',
    skip,
    variables: {
      filter: {
        ...options,
        used_by_curateddealbuyerdiscount_account_id: accountId,
      },
      path: 'curateddealbuyerdiscount.seat_ids',
    },
  });

  const { list, mapById } = useMemo(() => {
    const list = data?.optionsByPath.reduce<CuratedDealBuyerDiscountSeat[]>((acc, option) => {
      if (option) {
        acc.push({
          buyer_path: option.extra.buyer_path,
          demand_partner_id: option.extra.demand_partner_id,
          id: option.id,
          name: option.name,
          seat_id: option.extra.seat_id,
          used_by_curateddealbuyerdiscount: option.extra.used_by_curateddealbuyerdiscount,
        });
      }

      return acc;
    }, []);

    return {
      list: list ?? [],
      mapById: keyBy(list, 'id'),
    };
  }, [data]);

  return {
    isError: !!error,
    isLoading: loading,
    list,
    mapById,
  };
};
